export const MENU_INJECTION_KEY = 'rootMenu'

export const SUB_MENU_INJECTION_KEY = 'subMenu:'
